import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import _objectWithoutProperties from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.name";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
var _excluded = ["type", "needCSRF"],
  _excluded2 = ["type", "needCSRF", "strict"];
var _globalObject$locatio;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import axios from 'axios';
import extend from 'lodash-es/extend';
import isPlainObject from 'lodash-es/isPlainObject';
import { getCookie } from "./cookie";
import env from "./env";
import logger from "./logger";
import { buildCSRF, isNewQQLogin } from "./login";
import { globalContext, globalObject } from "./system";
import { buildQueryStr, buildUrl } from "./url";
import { hasOwn } from "./util";
export var RequestErrorType = {
  NETWORK_ERR: 'NETWORK_ERR',
  SYSTEM_ERR: 'SYSTEM_ERR',
  LOGIC_ERR: 'LOGIC_ERR'
};
var IS_STD_PROTOCOL = /^(http|https):$/.test((_globalObject$locatio = globalObject.location) === null || _globalObject$locatio === void 0 ? void 0 : _globalObject$locatio.protocol);
var HTTP2HTTP_PROXY = 'https://access.video.qq.com/trans/';
var HTTP2HTTP_APPID = '68106135';
var HTTP2HTTP_SECRETKEY = 'e667570eb833960cc41051d498df1c233308eb195dba2cc3';
var METHODS = getRequestMethods();
function getRequestMethods() {
  var requestor = env.isCSR ? globalContext.request : axios;
  return new Map([['get', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params, options) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return procHeaders(options);
            case 2:
              return _context.abrupt("return", requestor(extend({
                url: url,
                params: params,
                method: 'get'
              }, options)));
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }()], ['post', /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data, options) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return procHeaders(options);
            case 2:
              return _context2.abrupt("return", requestor(extend({
                url: url,
                data: data,
                method: 'post'
              }, options)));
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }()]]);
}
function procHeaders(_x7) {
  return _procHeaders.apply(this, arguments);
} /**
   * 通用的请求错误描述类
   * @param code
   * @param msg
   * @param res
   * @constructor
   */
function _procHeaders() {
  _procHeaders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(options) {
    var cookie;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!(options !== null && options !== void 0 && options.withCredentials) || !env.isHoneWeb || typeof HoneJSCoreJSBridge === 'undefined')) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", options);
          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return getCookie();
          case 5:
            cookie = _context3.sent;
            options.headers = options.headers || {};
            options.headers.Cookie = cookie;
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            logger.error('procHeaders error', _context3.t0);
          case 13:
            return _context3.abrupt("return", options);
          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 10]]);
  }));
  return _procHeaders.apply(this, arguments);
}
export function RequestError(code, msg, res, errorType) {
  this.code = code;
  this.msg = msg;
  this.res = res;
  this.errorType = errorType || RequestErrorType.LOGIC_ERR;
}
RequestError.prototype.toString = function () {
  return this.msg + (this.code ? "(".concat(this.code, ")") : '');
};
RequestError.prototype.RequestErrorType = RequestErrorType;
RequestError.RequestErrorType = RequestErrorType;

/**
 * 通用请求
 * @param url
 * @param data
 * @param options axios的其他option 如 timeout 具体查看 https://github.com/axios/axios#axios-api
 * @return Promise
 */
export function request(_x8) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url) {
    var data,
      options,
      csrfParam,
      type,
      needCSRF,
      others,
      method,
      res,
      _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            if (isNewQQLogin() && url.match(/\/\/pay.video.qq.com/)) {
              // QQ互联迁移
              url = url.replace(/\/\/(pay.video.qq.com)/, '//access.video.qq.com/trans/$1');
              if (!isPlainObject(data)) {
                data = {};
              }
              csrfParam = buildCSRF();
              extend(data, {
                vappid: HTTP2HTTP_APPID,
                vsecret: HTTP2HTTP_SECRETKEY
              }, csrfParam);
            }
            if (!IS_STD_PROTOCOL && /^\/\//.test(url)) {
              url = "https:".concat(url);
            }
            type = options.type, needCSRF = options.needCSRF, others = _objectWithoutProperties(options, _excluded);
            method = (type || 'get').trim().toLowerCase(); // 由于 axios 不支持 jsonp，需确保 url 参数带上 otype=xjson
            // 自动拼接 otype=xjson，以确保接口返回 json 对象数据
            if (url.match(/\/\/(pay|vip|hwvip)\.((video\.qq\.com)|(wetv\.vip))\//) || url.match(/\/_tde_\/vip_video_qq_com\/_tde_\//)) {
              if (url.indexOf('otype=') < 0) {
                url += "".concat(url.indexOf('?') > 0 ? '&' : '?', "otype=xjson");
              } else {
                url = url.replace('otype=json', 'otype=xjson');
              }
            }

            // 离线包场景或传了needCSRF=true,通过query方式传递
            if (!IS_STD_PROTOCOL || needCSRF) {
              csrfParam = buildCSRF();
              url = buildUrl(url, csrfParam);
            }
            if (method === 'post') {
              if (isPlainObject(data)) {
                // 兼容zepto的参数处理方式（如果要传json字符串，可以先调JSON.stringify(data)再传参；不建议直接传object，会触发预检，产生两次请求）
                data = buildQueryStr(data);
              }
            }

            // 用于请求携带cookie，如果没有设置withCredentials，则默认为true
            if (!hasOwn(options, 'withCredentials')) {
              others.withCredentials = !/(\/\/v\.qq\.com\/cache\/wuji)|(\/\/node\.video\.qq\.com\/x\/api\/wuji_cache)/.test(url);
            }
            _context4.prev = 10;
            _context4.next = 13;
            return METHODS.get(method).call(this, url, data, others);
          case 13:
            res = _context4.sent;
            if (!(res && res.status === 200 && res.data)) {
              _context4.next = 16;
              break;
            }
            return _context4.abrupt("return", res.data);
          case 16:
            throw new RequestError(0, '服务器开小差了！请重试', res, RequestErrorType.NETWORK_ERR);
          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](10);
            if (!(_context4.t0 instanceof RequestError)) {
              _context4.next = 23;
              break;
            }
            throw _context4.t0;
          case 23:
            throw new RequestError(0, '网络开小差了！请重试', _context4.t0, RequestErrorType.NETWORK_ERR);
          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[10, 19]]);
  }));
  return _request.apply(this, arguments);
}
export function nRequest(url) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return request(_formatNodeAPIUrl(url, args), null, {
    dataType: 'json'
  }).then(function (_ref3) {
    var ret = _ref3.ret,
      msg = _ref3.msg,
      data = _ref3.data;
    if (ret !== 0) {
      throw new RequestError(ret, msg, null, RequestErrorType.LOGIC_ERR);
    }
    return data;
  });
}
function _formatNodeAPIUrl(url, args) {
  if (!args.length) {
    return url;
  }
  var i = 0;
  return url.replace(/%(s|n)/g, function (m) {
    var v = args[i];
    i += 1;
    if (v === undefined || v === null) {
      v = '';
    }
    switch (m) {
      case '%n':
        return v;
      case '%s':
      default:
        return "\"".concat(v, "\"");
    }
  });
}
export function http2http(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return request("".concat(HTTP2HTTP_PROXY).concat(url.replace(/^(https:|http:)?\/\//, '')), _objectSpread(_objectSpread({}, params), {}, {
    vappid: HTTP2HTTP_APPID,
    vsecret: HTTP2HTTP_SECRETKEY
  }, buildCSRF()), options);
}
export function commConfig(configId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return commCGI({
    name: 'spp_get_confi',
    cmd: 1
  }, _objectSpread({
    config_id: configId
  }, params), options);
}
export function commCGI(_ref4) {
  var name = _ref4.name,
    cmd = _ref4.cmd;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isJson = options.dataType && options.dataType.toLowerCase() === 'json';
  if (options.withCredentials === true) {
    options = _objectSpread({
      xhrFields: {
        withCredentials: true
      }
    }, options);
  }
  return request("https://vip.video.qq.com/fcgi-bin/comm_cgi?name=".concat(name, "&cmd=").concat(cmd, "&otype=").concat(isJson ? 'xjson' : 'json'), params, options).then(function (res) {
    if (res && res.ret === -10) {
      throw new RequestError(res.ret, "CommCGI\u540D\u79F0\u672A\u914D\u7F6E(name=".concat(name, ")"), res, RequestErrorType.SYSTEM_ERR);
    }
    return res;
  });
}

/**
 * rpcCGI 支持调用 rpcGo 的接口
 * @param {string} path rpc路由
 * @param {object} data 参数
 * @param {object} options 请求设置
 * @param {Boolean} options.strict 是否启用严格模式，启用后将严格按照接口规范，通过 response header trpc-func-ret 字段是否等于0判断请求是否成功，而不关心 body。
 * 该参数主要是为了修复并兼容低版本——如果body为空即认为请求失败——的问题
 * @example
 * // 请求接口 http://vip.video.qq.com/rpc/trpc.kidsvip.checkinfo.KidsVipService/KidsVipCheckInfo
 * try {
 *   await rpcCGI('trpc.kidsvip.checkinfo.KidsVipService/KidsVipCheckInfo')
 * } catch (e) {
 * }
 */
export function rpcCGI() {
  return _rpcCGI.apply(this, arguments);
}
function _rpcCGI() {
  _rpcCGI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var path,
      data,
      options,
      type,
      needCSRF,
      strict,
      others,
      method,
      url,
      csrfParam,
      res,
      _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            path = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : '';
            data = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            type = options.type, needCSRF = options.needCSRF, strict = options.strict, others = _objectWithoutProperties(options, _excluded2);
            method = (type || 'get').trim().toLowerCase();
            others.withCredentials = true;
            if (method === 'post') {
              others.headers = {
                'Content-Type': 'text/plain;charset=utf-8'
              };
              if (isPlainObject(data)) {
                data = JSON.stringify(data);
              }
            } else if (method === 'get' && isPlainObject(data) && !data.rpc_data) {
              // 兼容处理业务自己透传的 rpc_data 参数，不再处理
              data = {
                rpc_data: JSON.stringify(data)
              };
            }
            url = "//vip.video.qq.com/rpc/".concat(path);
            if (path.match(/^(https?:)?\/\//)) {
              url = path;
            }
            if (!IS_STD_PROTOCOL && /^\/\//.test(url)) {
              url = "https:".concat(url);
            }
            // 离线包场景或传了needCSRF=true,通过query方式传递
            if (!IS_STD_PROTOCOL || needCSRF) {
              csrfParam = buildCSRF();
              url = buildUrl(url, csrfParam);
            }
            _context5.prev = 11;
            _context5.next = 14;
            return METHODS.get(method).call(this, url, data, others);
          case 14:
            res = _context5.sent;
            if (!(res.status !== 200)) {
              _context5.next = 17;
              break;
            }
            throw new RequestError(res.status, '网络请求失败', res, RequestErrorType.SYSTEM_ERR);
          case 17:
            if (!(
            // 严格模式遵循接口规范，仅根据 header 字段 trpc-func-ret 和 trpc-ret 判断
            // 接口规范：https://git.woa.com/video_pay_baseplat/ff_rule/trpc_http_rule
            strict && (Number(res.headers['trpc-func-ret']) !== 0 || Number(res.headers['trpc-ret']) !== 0)
            // 兼容低版本——如果body为空即认为请求失败——的逻辑
            || !strict && !res.data)) {
              _context5.next = 19;
              break;
            }
            throw new RequestError(res.headers['trpc-func-ret'] || res.headers['trpc-ret'] || -999, res.headers['trpc-error-msg'] || '请求错误', res, RequestErrorType.LOGIC_ERR);
          case 19:
            return _context5.abrupt("return", res.data);
          case 22:
            _context5.prev = 22;
            _context5.t0 = _context5["catch"](11);
            if (!(_context5.t0 instanceof RequestError)) {
              _context5.next = 26;
              break;
            }
            throw _context5.t0;
          case 26:
            throw new RequestError(0, '网络开小差了！请重试', _context5.t0, RequestErrorType.NETWORK_ERR);
          case 27:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[11, 22]]);
  }));
  return _rpcCGI.apply(this, arguments);
}